import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const KyrgyzstanFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15272'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15272)'>
				<rect
					width='20'
					height='14'
					fill='#F22A46'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.0001 9.33329C11.3151 9.33329 12.381 8.28862 12.381 6.99996C12.381 5.71129 11.3151 4.66663 10.0001 4.66663C8.68513 4.66663 7.61914 5.71129 7.61914 6.99996C7.61914 8.28862 8.68513 9.33329 10.0001 9.33329Z'
					fill='#FFF04D'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.83423 12.0046L9.99981 10.2995L11.1654 12.0046L11.4606 9.97276L13.2657 11.0134L12.6321 9.05721L14.7192 9.22726L13.2823 7.73421L15.2379 6.99999L13.2823 6.26578L14.7192 4.77272L12.6321 4.94277L13.2657 2.98659L11.4606 4.02722L11.1654 1.99536L9.99981 3.70046L8.83423 1.99536L8.53899 4.02722L6.73391 2.98659L7.36749 4.94277L5.28045 4.77272L6.71736 6.26578L4.76172 6.99999L6.71736 7.73421L5.28045 9.22726L7.36749 9.05721L6.73391 11.0134L8.53899 9.97276L8.83423 12.0046ZM13.3331 6.99999C13.3331 8.80412 11.8408 10.2667 9.99981 10.2667C8.15886 10.2667 6.66648 8.80412 6.66648 6.99999C6.66648 5.19586 8.15886 3.73332 9.99981 3.73332C11.8408 3.73332 13.3331 5.19586 13.3331 6.99999Z'
					fill='#FFF04D'
				/>
			</g>
		</svg>
	);
};

export default KyrgyzstanFlagIcon;
